import { render } from "./DeferredInvitationBanner.vue?vue&type=template&id=a3dc8f40&scoped=true"
import script from "./DeferredInvitationBanner.vue?vue&type=script&lang=js"
export * from "./DeferredInvitationBanner.vue?vue&type=script&lang=js"

import "./DeferredInvitationBanner.vue?vue&type=style&index=0&id=a3dc8f40&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a3dc8f40"

export default script